import * as React from 'react';
import {ApolloProvider} from 'react-apollo';
import ReactDOM from 'react-dom';
import {Provider} from 'react-redux';
import {Router} from 'react-router-dom';

import {ApolloProvider as ReactHooksApolloProvider} from '@apollo/react-hooks';

import {nutApolloClient} from '../../../apollo-client';
import {appHistory} from '../../../history';
import {store} from '../../../store';

import {DirectorySyncUsersBanner} from './banners/ds-users-banner';

const DS_USERS_BANNER_REACT_MOUNT_ID = 'ds-users-banner-react-mount';
const ENABLED_USER_STATUS = '0';

export function mountDsUsersBanner() {
    const urlParams = new URLSearchParams(window.location.search);
    const viewingEnabledUsers = urlParams.get('status') === ENABLED_USER_STATUS;

    if (!viewingEnabledUsers) {
        return null;
    }

    const mount = document.getElementById(DS_USERS_BANNER_REACT_MOUNT_ID);

    if (mount) {
        ReactDOM.render(
            <Provider store={store}>
                <ApolloProvider client={nutApolloClient}>
                    <ReactHooksApolloProvider client={nutApolloClient}>
                        <Router history={appHistory}>
                            <DirectorySyncUsersBanner />
                        </Router>
                    </ReactHooksApolloProvider>
                </ApolloProvider>
            </Provider>,
            mount
        );
    }
}
